export const getEnumDescription = (value: any, enums: Array<any>) => {
  if (value === null || value === undefined) return null;

  return enums.find(e => e.Value === value)?.Description;
};
